/**
 * Old helper functions.
 * Leave me alone.
 */

const tabbableElementSelectors = [
	'a[href]:not([tabindex^="-"])',
	'area[href]:not([tabindex^="-"])',
	'input:not([disabled]):not([tabindex^="-"]):not([type="hidden"])',
	'select:not([disabled]):not([tabindex^="-"])',
	'textarea:not([disabled]):not([tabindex^="-"])',
	'button:not([disabled]):not([tabindex^="-"])',
	'iframe:not([tabindex^="-"])',
	'[tabindex]:not([tabindex^="-"])',
	'[contentEditable=true]:not([tabindex^="-"])',
]

export function allFocusOut( elements ) {
	elements.on( 'focusout', function( event ) {
		var element = window.jQuery( this );
		window.setTimeout( function() {
			if ( ! element.has( document.activeElement ).length ) {
				element.trigger( 'allfocusout' );
			}
		}, 0);
	});
}

export function isVisible( index, element ) {
	element = window.jQuery(element);
	var visibility = element.css( 'visibility' );
	while ( visibility === 'inherit' ) {
		element = element.parent();
		visibility = element.css( 'visibility' );
	}
	return visibility !== 'hidden';
}

export function focusFirstTabbableElement( container, exclusions = '', includeContainer = false ) {

	var tabbableElements = container.find( tabbableElementSelectors.join( ',' ) ).filter( ':visible' ).filter( isVisible )

	if ( includeContainer && container.is( tabbableElementSelectors.join( ',' ) ) ) {
		tabbableElements = container.add( tabbableElements )
	}

	if ( exclusions ) {
		tabbableElements = tabbableElements.not( exclusions )
	}
	if ( tabbableElements.length ) {
		tabbableElements[0].focus( { preventScroll: true } )
	}
	return container;
}